<template>
  <v-dialog v-model="visible" content-class="ac--size" v-click-outside="close">
    <v-card>
      <v-card-title class="title font-weight-regular justify-space-between">
        <span>{{ currentTitle }}</span>
      </v-card-title>

      <v-window v-model="step">
        <v-window-item :value="1">
          <search :searchFilter.sync="searchFilter" />

          <v-list class="ac--scroll-list">
            <v-list-tile
              v-for="item in filteredItems"
              :key="item.title"
              @click="onContactClicked(item)"
              :class="selected(item)"
              style="height: 45px !important;"
            >
              <v-list-tile-avatar>
                <user-avatar 
                  :avatar="item.avatar"
                  :username="item.name" 
                  :size="38"
                />
              </v-list-tile-avatar>

              <v-list-tile-content>
                <v-list-tile-title v-text="item.name" ></v-list-tile-title>
              </v-list-tile-content>

            </v-list-tile>
          </v-list>
        </v-window-item>

        <v-window-item :value="2">
          <div class="pa-3 text-xs-center ac--fix-height" :v-if="step === 2">
            <div style="height:100px;"></div>
            <user-avatar 
              id = "chatAvatarCtrl"
              :avatar="chatAvatar"
              :username="chatTitle" 
              :size="192"
              :onClick ="selectAvatar"
            />

            <v-text-field
              v-model="chatTitle"
              :label="$t('chat_title')"
            />
          </div>
        </v-window-item>
      </v-window>

      <v-divider></v-divider>

      <v-card-actions>
        <v-btn
          flat
          @click="back"
        >
            {{ backTitle }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          :loading="loading"
          :disabled="nextDisabled"
          color="primary"
          depressed
          @click="next"
        >
          {{ nextTitle }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style>
  .ac--size {
    width: 350px !important;
    height: 600px;
  }
  .ac--scroll-list {
    height: 458px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  .ac--scroll-list:not(.focus):not(:hover)::-webkit-scrollbar {
    display: none;
  }
  .ac--fix-height {
    height: 495px;
  }
  .v-card__title.title > span {
    white-space:nowrap;
  }
</style>

<script> 
  import UserAvatar from '@common/UserAvatar.vue'
  import fileSelector from '@utils/fileSelector'
  import fileUtils from '@utils/fileUtils'
  import Search from '@common/Search.vue'

  export default {
    data: () => ({
      items: [],
      selectedItems: [],
      loading: false,
      step: 1,
      result: 0,
      chatTitle: "",
      chatAvatar: "",
      searchFilter:'',
      filteredItems: []
    }),
    components: { UserAvatar, Search },
    computed: {
      currentTitle () {
        return (this.step === 1) ? this.$t('select_user_to_chat') : this.$t('enter_chat_name')
      },
      nextTitle() {
        return (this.step === 1) ? this.$t('next_btn') : this.$t('save_btn')
      },
      backTitle() {
        return (this.step === 1) ? this.$t('cancel') : this.$t('back_btn')
      },
      nextDisabled() {
        return this.selectedItems.length == 0 && this.step == 1
      }
    },
    props: {
      visible: {
        type: Boolean, 
        default: false
      },
      append: {
        type: Boolean, 
        default: false 
      },
      contacts: {
        type: Array,
        default: () => [],
        required: false
      },
      callback: Function,
    },
    methods: {
      fetchContacts() {
        //console.log('-- fetchContacts', this.append, this.contacts)
        this.$store.dispatch('fetchContacts').then(resp => {
          this.items = resp.filter(item => !this.contacts.includes(item.contactId))
          this.filteredItems = this.items
        })
      },
      close() {
        if (!this.visible)
          return
        // reset all variables
        this.step = 1
        this.result = 0
        this.selectedItems = []
        this.chatTitle = ""
        this.chatAvatar = ""
        this.$emit('update:visible', false)
        this.searchFilter = ""
      },
      selectedContacts() {
        let users = []
        this.selectedItems.forEach((item) => users.push(item.contactId))
        return users
      },
      next() {
        if (this.callback !== undefined) {
          this.callback(this.selectedContacts())
          this.close()
          return
        }

        if (this.append) {
          this.$store.dispatch('addUsersToCurrentChat', this.selectedContacts())
          this.close()
          return         
        }

        if (this.step < 2) {
          if (this.selectedItems.length == 1) {
            this.$store.dispatch('openSingleChat', { 
              chatId: this.selectedItems[0].chatId, 
              contactId: this.selectedItems[0].contactId 
            })
            this.close()
            return
          }
          this.step++
          this.setChatTitle()
          return  
        }

        this.$store.dispatch('addChat', { 
          users: this.selectedContacts(), 
          avatar: this.chatAvatar,
          title: this.chatTitle
        })
        this.close()
      },
      back() {
        if (this.step == 1) {
          this.close()
          return
        }
        this.step--
      },
      selected(item) {
        return (this.selectedItems.includes(item)) ? 'accent' : ''
      },
      onContactClicked(item){
        if (this.selectedItems.includes(item)) {
          this.selectedItems.splice(this.selectedItems.indexOf(item), 1 )
        } else {
          this.selectedItems.push(item)
        }
      },
      setChatTitle() {
        let title = ""
        this.selectedItems.forEach(item => {
          if (title != "")
            title += ', '
          title += item.name
        })
        this.chatTitle = title
      },
      selectAvatar() {
        let fileName = fileSelector.openAvatarImage()
        if (fileName) {
          // TODO: move to dispatch
          /** 
          const newAvatarName = EventBus.generateAvatarFileName(fileName)
          const newAvatarPath = EventBus.getUserFolderPath() + newAvatarName
          console.log('-- newAvatarPath: ' + newAvatarPath)
          fileUtils.copyAttach(fileName, newAvatarPath).then(() => this.chatAvatar = newAvatarPath)
          */
        }
      }
    },
    watch: {
      visible: function(newValue, oldValue) {
        if (newValue)
          this.fetchContacts()
      },
      searchFilter: function(newValue, oldValue) {
        if (newValue && this.searchFilter!== '') {
          const filter = new RegExp(this.searchFilter, 'i')
          this.filteredItems = this.items.filter(it => it.name.match(filter))
          this.selectedItems = this.selectedItems.filter(it => it.name.match(filter))
        }
        else {
          this.filteredItems = this.items
        }
      }
    }
  }
</script>